var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilledCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3636 13.0909H4.36364C3.96364 13.0909 3.62133 12.9486 3.33673 12.664C3.05164 12.3789 2.90909 12.0364 2.90909 11.6364V1.45455C2.90909 1.05455 3.05164 0.712 3.33673 0.426909C3.62133 0.142303 3.96364 0 4.36364 0H9.45455L13.8182 4.36364V11.6364C13.8182 12.0364 13.6759 12.3789 13.3913 12.664C13.1062 12.9486 12.7636 13.0909 12.3636 13.0909ZM8.72727 5.09091V1.45455H4.36364V11.6364H12.3636V5.09091H8.72727ZM1.45455 16C1.05455 16 0.712242 15.8577 0.427636 15.5731C0.142546 15.288 0 14.9455 0 14.5455V4.36364H1.45455V14.5455H9.45455V16H1.45455ZM4.36364 1.45455H8.72727V5.09091H12.3636L8.72727 1.45455V5.09091H12.3636V11.6364H4.36364V1.45455Z",
    fill: "#1C1B1F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilledCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filled_copy.931fa4e8.svg";
export { ForwardRef as ReactComponent };